import React from "react";
import ChatTemplate from "../components/template/ChatTemplate";

function Chat() {
  return (
    <>
      <ChatTemplate />
    </>
  );
}

export default Chat;
